import styled from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { FormField } from 'ui/formField';
import { Link } from 'ui/links';
import { colors, spacing } from 'ui/theme';

export const StyledBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.plusHalf};
`;

export const StyledLink = styled(Link)`
  font-size: inherit;
  color: ${colors.link};
  border-bottom: unset;
`;

export const ErrorMessageContainer = styled.div`
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
`;

export const NotificationTypeFieldWrapper = styled(FormField)`
  > p {
    margin-bottom: ${spacing.threeQuarter};
  }
`;

export const SecondaryText = styled.span`
  color: ${colors.textSecondary};
`;
